/** Workstations (docs/design/ideas/2026-10-11-workstations.md), first test: the anvil only. Content is data. */
export type PadKind = 'town' | 'wild';
export interface PadDef {
  id: string;
  kind: PadKind;
  /** Authored world spot (metres). */
  x: number;
  y: number;
  label: string;
}
export const PADS: readonly PadDef[] = [
  { id: 'town-1', kind: 'town', x: 4, y: 4, label: 'ลานตีเหล็กในเมือง' },
  { id: 'wild-1', kind: 'wild', x: 40, y: 22, label: 'จุดพลังป่าเขา' },
];
export const ANVIL = { id: 'anvil', price: 120, label: 'ทั่งตีเหล็ก' } as const;
export const STATIONS = {
  /** Forge time in real ms: 60 s stands in for the design's 1 h. */
  jobMs: 60_000,
  /** Base yield; the wild power-spot adds a bonus on top. */
  baseYield: 1,
  wildBonus: 1,
  /** Collect minigame: cursor sweeps 0..1 (ping-pong, `sweepMs` per way); hit inside the zone. */
  sweepMs: 900,
  goodZone: 0.18,
  perfectZone: 0.05,
  perfectBonus: 1,
  /** Bandit raid on a wild pad: chance per job at completion time, and when it can strike (fraction of the job). */
  raidChance: 0.5,
  /** Fee another player pays to use your anvil (stub). */
  useFee: 10,
} as const;
export const FORGE_OUTPUT = { id: 'iron-blade', label: 'ดาบเหล็ก' } as const;
